<template>
  <div class="tab_wrapper">
    <div class="tab_container">
      <div class="tab_header">
        <p class="header-title" v-html="tabData[0].title"></p>
      </div>
      <div class="tab_content">
        <div :class="['tab-item', 'tab-item_' + index]" v-for="(item, index) in tabData" :key="index">
          <div class="tab_title_wrapper">
            <p class="tab-title" v-html="item.boxTitle"></p>
            <br v-if="item.haveBR"/>
          </div>
          <div :class="['tab_content_wrapper', {'bigger': item.bigger, 'biggest': item.biggest}]">
            <div class="tab-percent_container">
              <p class="tab-percent" v-html="item.boxPercent"></p>
            </div>
            <div class="tab-text_container">
              <p class="tab-text" v-html="item.boxText"></p>
            </div>
            <div class="tab-footnote_container">
              <p class="tab-footnote" v-html="item.boxFootnotes"></p>
            </div>
          </div>
          <div class="tab_triangle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Tabs',
  props: [
    'tabData'
  ],
  data() {
    return {};
  },
  computed: {
    ...mapState([
      'userAgent',
    ]),
    isIE() {
      return this.userAgent.browser.name === 'ie';
    },
  },
  methods: {},
  created() {
  },
  mounted() {
  },
  watch: {}
};
</script>

<style lang="scss">
.tab_wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 20px 0;

  .tab_container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
}

.tab_header {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $accent;
  padding: 5px 20px;
  width: 100%;
}

.tab_content {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 5px 0 10px 0;
  align-items: flex-start;
  justify-content: space-between;

  .tab-item {
    display: flex;
    flex-direction: column;
    padding-left: 30px;

    &:first-child {
      padding-left: 0;
      @include media("<tablet") {
        padding-top: 0;
      }
    }

    @include media("<tablet") {
      padding-left: 0;
      padding-top: 20px;
    }
  }

  @include media("<tablet") {
    flex-direction: column;
  }
}

.tab_triangle {
  width: 100%;
  height: 0;
  border-style: solid;
  border-width: 40px 120px 0 120px;
  border-color: $accent transparent transparent transparent;
  margin-top: -0.1px;
  @include media("<=tablet") {
    margin-top: -0.3px;
  }
}

// TEXT CONTAINERS
.tab_title_wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 10px 5px 10px;
}

.tab_content_wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5px;
  background-color: $accent;

  .tab-percent_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .tab-text_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 5px 0;
  }

  .tab-footnote_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
}

// TEXT
.header-title {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.88;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.tab-title {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #143965;
}

.tab-percent {
  font-family: 'Roboto', sans-serif;
  font-size: 42px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.tab-text {
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.tab-footnote {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;

  i {
    font-style: italic;
  }
}

//
.percent {
  display: inline-block;
  vertical-align: top;
  line-height: normal;
  font-size: 80%;
}

.bigger {
  padding: 10px 10px 60px 10px;
}

.biggest {
  padding: 10px 10px 90px 10px;
}

</style>
